import { CollaboratorService } from "../../core/http/service/CollaboratorService";
import { SchedulingService } from "../../core/http/service/SchedulingService";
import BaseResponse from "../../models/core/BaseResponse";
import SchedulingCard from "../../models/core/scheduling/SchedulingCard";
import DependentesListaModel from "../../models/dependente/DependentesListaModel";


export const FETCH_RESULTS = "FETCH_RESULTS";
export const FETCH_DEPENDENTE_RESULTS = "FETCH_DEPENDENTE_RESULTS";
export const FETCH_DEPENDENTE_START = "FETCH_DEPENDENTE_START";
export const FETCH_DEPENDENTE_END = "FETCH_DEPENDENTE_END";
export const FETCH_SCHEDULING_START = "FETCH_SCHEDULING_START";
export const FETCH_SCHEDULING_END = "FETCH_SCHEDULING_END";

const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

export const getResultsScheduling = () => {
  const service = new SchedulingService();

  return async (dispatch: any) => {
    try {
      const response: any = await service.getConsults();

      const scheduling: BaseResponse<any> = new BaseResponse().fromJSON(
        response.data
      );

      const schedulingCard: SchedulingCard[] = [];

      scheduling?.data?.forEach((data: any) => {
        schedulingCard.push(new SchedulingCard().fromJSON(data));
      });

      dispatch({
        type: FETCH_RESULTS,
        scheduling: schedulingCard,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const getResultsSchedulingPerson = (pacienteId: string) => {
  const service = new SchedulingService();

  return async (dispatch: any) => {
    try {
      const response: any = await service.getConsultsPacientId(pacienteId);

      const scheduling: BaseResponse<any> = new BaseResponse().fromJSON(
        response.data
      );

      const schedulingCard: SchedulingCard[] = [];

      scheduling?.data?.forEach((data: any) => {
        schedulingCard.push(new SchedulingCard().fromJSON(data));
      });

      dispatch({
        type: FETCH_RESULTS,
        scheduling: schedulingCard,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const getDependente = (body: any) => {
  const service = new CollaboratorService();

  return async (dispatch: any) => {
    dispatch({ type: FETCH_DEPENDENTE_START });
    try {
      const dependentesLista: DependentesListaModel[] = [];
      const response: any = await service.BuscarDependentes(body);

      if (response && response.data && response.data.data && response.data.data.length > 0 && response.status == 200) {
        response.data.data.forEach((d: any) => {
          dependentesLista.push(d)
        });
      }

      dispatch({
        type: FETCH_DEPENDENTE_END,
        dependenteColaborador: dependentesLista,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      dispatch({ type: FETCH_DEPENDENTE_END, dependenteColaborador: [] }); // Lida com o erro finalizando o carregamento
    }
  };
};

export const limparDependente = () => {
  return async (dispatch: any) => {
    const dependentesLista: DependentesListaModel[] = [];
    dispatch({
      type: FETCH_DEPENDENTE_RESULTS,
      dependenteColaborador: dependentesLista,
    });
  };
};